export default {
  tab: {
    all: 'All Activities',
    bonus: 'Bonus Activities',
    trading: 'Trading Activities',
    promotion: 'Promotion Activities',
  },
  tag: {
    bonus: 'Bonus',
    trading: 'Trading',
    promotion: 'Promotion',
  },
  period: 'Activity Period: ',
  connector: {
    to: 'to',
    dash: '-',
  },
}
